(function() {
  const cache = new Map();
  let observerInitialized = false;

  function buildEntry(context) {
    const url = context.dataset.approverUrl || "/pages/pending-approvals";
    const label = context.dataset.approverLabel || "Pending approvals";
    const iconHtml = context.dataset.approverIconHtml || "";
    const variant = context.dataset.approverVariant || "desktop";

    const entry = document.createElement("a");
    entry.href = url;
    entry.dataset.approverEntry = "true";

    if (variant === "mobile") {
      entry.className = "header__button body2";
      entry.innerHTML = `${iconHtml}${label}`;
      return entry;
    }

    entry.className = "btn btn--border btn__transition-text w-full";
    entry.innerHTML = `
      <div class="btn__texts">
        <span class="btn__top-text is-visible">${iconHtml}${label}</span>
        <span class="btn__bottom-text is-hidden">${iconHtml}${label}</span>
      </div>
    `;
    return entry;
  }

  async function loadApproverAccess(context) {
    const companyId = context.dataset.approverCompanyId || "";
    const companyContactId = context.dataset.approverContactId || "";
    const locationId = context.dataset.approverLocationId || "";
    const shop = context.dataset.approverShop || "";

    if (!companyId || !companyContactId) {
      return { authorized: false };
    }

    const cacheKey = [companyId, companyContactId, locationId, shop].join(":");
    if (cache.has(cacheKey)) {
      return cache.get(cacheKey);
    }

    const searchParams = new URLSearchParams({
      companyId,
      companyContactId,
    });

    if (locationId) searchParams.set("locationId", locationId);
    if (shop) searchParams.set("shop", shop);

    const request = fetch(`/apps/b2b-order-approval/approver-access?${searchParams.toString()}`, {
      cache: "no-store",
      credentials: "same-origin",
      headers: { accept: "application/json" },
    })
      .then(async (response) => {
        const payload = await response.json().catch(() => ({}));
        if (!response.ok) {
          return { authorized: false, error: payload.error || "Could not load approver access." };
        }
        return payload;
      })
      .catch(() => ({ authorized: false, error: "Could not load approver access." }));

    cache.set(cacheKey, request);
    return request;
  }

  function isAuthorizedForContext(context, payload) {
    const hasCurrentLocation = Boolean(context.dataset.approverLocationId || "");
    if (hasCurrentLocation) {
      return Boolean(payload?.authorizedForCurrentLocation);
    }

    return Boolean(payload?.authorized);
  }

  function getContexts() {
    return document.querySelectorAll("[data-approver-context]");
  }

  async function revealLinks() {
    const contexts = getContexts();
    if (!contexts.length) return;

    for (const context of contexts) {
      if (context.dataset.approverResolved === "true") continue;

      const payload = await loadApproverAccess(context);
      context.dataset.approverResolved = "true";
      const entryLinks = context.querySelectorAll("[data-approver-entry]");

      if (!isAuthorizedForContext(context, payload)) {
        entryLinks.forEach((entry) => {
          entry.remove();
        });
        continue;
      }

      if (!entryLinks.length) {
        context.appendChild(buildEntry(context));
        continue;
      }

      entryLinks.forEach((entry) => {
        entry.style.removeProperty("display");
      });
    }
  }

  function initObserver() {
    if (observerInitialized) return;
    observerInitialized = true;

    const observer = new MutationObserver(() => {
      revealLinks();
    });

    observer.observe(document.documentElement, {
      childList: true,
      subtree: true,
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => {
      revealLinks();
      initObserver();
    }, { once: true });
  } else {
    revealLinks();
    initObserver();
  }

  window.addEventListener("pageshow", revealLinks);
  window.addEventListener("load", revealLinks);
})();
